import { isValidElement } from 'react';
import { isString, isNumber, isFunction } from '../../../utils/assertion';
export var parseClassName = function (v) {
    return isString(v) || isFunction(v) ? v : null;
};
export var getAutoCloseDelay = function (toastAutoClose, containerAutoClose) {
    return toastAutoClose === false || (isNumber(toastAutoClose) && toastAutoClose > 0)
        ? toastAutoClose
        : containerAutoClose;
};
export var canBeRendered = function (content) {
    return isValidElement(content) ||
        isString(content) ||
        isFunction(content) ||
        isNumber(content);
};
export { isString, isNumber, isFunction };
